import * as _ from 'underscore';

//import { validators } from '../../../../_common/platform/ts/validators';

// Theme dispatcher module
import * as appTheme from '../../../../_common/platform/ts/appTheme';
import toolbarButtons from '../../../../pdc-platform/src/ts/themes/toolbarButtonsTheme';

// Any dependency themes, which should be initialized before this one
import { init as widgetTheme } from '../../../../pdc-platform/src/ts/themes/widgetTheme';
import * as Config from '../config';
import BooleanField from '../../../../_common/platform/ts/BooleanField';

// This array, which saves all glob objects, on which theme was initialized
// It's used to make sure that `init` is launched only once for each glob.
// Here, it's possible that platform will run init for widgetTheme more than 1 time.
let _init = [];

export function init(glob) {
    // If init already invoked – halt
    if (_.indexOf(_init, glob) !== -1) {
        return;
    }

    // Init parent theme
    widgetTheme(glob);

    // Register section, which will be displayed on the left of theme edit component
    appTheme.registerSections([
        {
            id: Config.themeId,
            name: Config.name,
            parent: 'widget',

            themeType: 'Toolbar Filter',
            visibility: ['application', 'workspace', Config.moduleName]
        }
    ]);

    // Register theme variables
    // appTheme.registerVars([
    // ]);

    toolbarButtons(
        glob,
        Config.themeId,
        Config.moduleName,
        Config.themeFields.section_Buttons,
        Config.themeFields.justifyButtons,
        Config.themeFields.showResetButton,
        Config.themeFields.resetButtonShowMode,
        Config.themeFields.showApplyButton,
        Config.themeFields.showRefreshButton,
        Config.themeFields.refreshButtonShowMode
        // Config.themeFields.showCancelButton,
        // Config.themeFields.cancelButtonShowMode
    );

    appTheme.registerVars([
        {
            id: Config.themeFields.showUndoAndRedoButtons,
            param: new BooleanField(glob, 'Show Undo and Redo Buttons', [], true),
            section: Config.themeFields.section_Buttons
        }
    ]);

    appTheme.registerPreRender(function (input) {
        var vars = {};

        return _.extend(input, vars);
    });

    _init.push(glob);
}
